import React, { useEffect } from 'react';
import './AccommodationForm.css';
import { useLang } from '../i18n';

// Small site-styled notice dialog (dark teal, pill button) — replaces window.alert
// for messages like "Registration is not open yet."
function NoticeModal({ icon, text, onClose }) {
  const { t } = useLang();

  useEffect(() => {
    const prev = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    const onKey = (e) => { if (e.key === 'Escape') onClose(); };
    document.addEventListener('keydown', onKey);
    return () => {
      document.body.style.overflow = prev;
      document.removeEventListener('keydown', onKey);
    };
  }, [onClose]);

  return (
    <div className="af-overlay" onClick={onClose}>
      <div
        className="af-modal af-modal--notice"
        role="dialog"
        aria-modal="true"
        aria-label={text}
        onClick={(e) => e.stopPropagation()}
      >
        <div className="af-success" style={{ padding: '36px 28px 8px' }}>
          <div className="af-success-icon">
            <i className={icon || 'fas fa-hourglass-half'} aria-hidden="true"></i>
          </div>
          <div className="af-success-title" style={{ fontSize: 20 }}>{text}</div>
        </div>
        <div className="af-footer" style={{ justifyContent: 'center', borderTop: 'none' }}>
          <button className="af-btn-primary" onClick={onClose} autoFocus>{t('booking.btnClose')}</button>
        </div>
      </div>
    </div>
  );
}

export default NoticeModal;
